"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpacingValue = void 0;
var _useScaleDensity = require("@cbhq/cds-common/scale/useScaleDensity");
const useSpacingValue = val => {
  const scale = (0, _useScaleDensity.useScaleDensity)();
  return scale === 'dense' ? val * 4 : val * 8;
};
exports.useSpacingValue = useSpacingValue;